<template>
  <section>
    <p class="title is-1">Reporte de cuentas</p>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Cuentas</b-breadcrumb-item>
    </b-breadcrumb>
    <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />
    <div class="columns is-variable is-2 mt-4 filtros-reporte">
      <div class="column">
        <busqueda-cliente @seleccionado="onSeleccionado" @deseleccionado="onDeseleccionado" />
      </div>
      <div class="column is-narrow filtro-estado">
        <b-field label="Estado de la cuenta">
          <b-select v-model="filtros.estado" @input="onEstadoChange" expanded>
            <option value="">Todas las cuentas</option>
            <option value="LIQUIDADO">Liquidadas</option>
            <option value="VIGENTE">Vigentes</option>
            <option value="VENCIDA">Vencidas</option>
          </b-select>
        </b-field>
      </div>
    </div>
    <b-modal v-model="abrirModalLocal" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog"
      aria-label="Modal Seleccionar Local" close-button-aria-label="Close" aria-modal>
      <div class="modal-card" style="width: 320px">
        <section class="modal-card-body">
          <b-field class="mt-3" label="Local emisor">
            <b-select class="wide" placeholder="Seleccionar..." v-model="local" required>
              <option value="jiro">Jirosushi Prime</option>
              <option value="ccs">Oferta Caracas</option>
              <option value="prime">Food Prime</option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <b-button label="Continuar" type="is-primary" @click="confirmarLocal" :disabled="!local" />
        </footer>
      </div>
    </b-modal>
    <mensaje-inicial class="mt-2" :titulo="'No se han encontrado cuentas :('"
      :subtitulo="'Aquí aparecerán las cuentas registradas'" v-if="cuentas.length < 1" />
    <div class="mt-2" v-if="cuentas.length > 0">
      <cartas-totales-filtradas :registros="totalesGenerales" :formatoMonto="formatoMonto" />
      <cartas-totales-filtradas :registros="cuentasFiltradas" :formatoMonto="formatoMonto" />
      <tabla-cuentas-apartados :datos="cuentas" :printHref="printHref" :formatoMonto="formatoMonto"
        :filtros="filtrosCompletos" @imprimir="onGenerarComprobante" :tasa="tasa" :currentPage="currentPage"
        :perPage="perPage" :total="total" @page-change="onPageChange" @per-page-change="onPerPageChange" />
    </div>
    <comprobante-compra :venta="this.cuentaSeleccionada" :tipo="'cuenta'" @impreso="onImpreso" v-if="mostrarComprobante"
      :porPagar="porPagar" :tamaño="tamaño" :enviarCliente="enviarCliente" :local="local" :tasa="tasa" />
    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import BusquedaCliente from '../Clientes/BusquedaCliente'
import BusquedaEnFecha from '../Extras/BusquedaEnFecha'
import MensajeInicial from '../Extras/MensajeInicial'
import CartasTotalesFiltradas from '../Extras/CartasTotalesFiltradas'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import TablaCuentasApartados from './TablaCuentasApartados'
import ComprobanteCompra from './ComprobanteCompra'

export default {
  name: "ReporteCuentas",
  components: { BusquedaEnFecha, TablaCuentasApartados, MensajeInicial, CartasTotalesFiltradas, ComprobanteCompra, BusquedaCliente },

  data: () => ({
    tasa: null,
    filtros: {
      fechaInicio: "",
      fechaFin: "",
      // '' = todas. LIQUIDADO / VIGENTE / VENCIDA se calculan igual que en la tabla.
      estado: ""
    },
    tamaño: 'tiquera',
    cargando: false,
    cuentas: [],
    currentPage: 1,
    perPage: 5,
    total: 0,
    totalesGenerales: [],
    cuentaSeleccionada: null,
    mostrarComprobante: false,
    porPagar: 0,
    enviarCliente: false,
    clienteId: null,
    cuentasFiltradas: [],
    local: null,
    abrirModalLocal: false,
  }),

  mounted ()
  {
    this.obtenerCuentas()
  },

  computed: {
    printHref ()
    {
      let href = '#/pdf/cuentas'

      const entries = Object.entries(this.filtros)
        .filter(entry => Boolean(entry[1]))

      if (this.clienteId) {
        entries.push(['clienteId', this.clienteId])
      }

      if (entries.length === 0) return href

      const filtros = Object.fromEntries(entries)
      const params = new URLSearchParams(filtros).toString()
      return `${href}?${params}`
    },
    filtrosCompletos ()
    {
      return {
        ...this.filtros,
        clienteId: this.clienteId || null,
        clienteNombre: this.clienteSeleccionado ? this.clienteSeleccionado.nombre : null,
        tipo: 'cuenta',
      }
    }
  },

  methods: {
    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    },

    onImpreso (resultado)
    {
      this.mostrarComprobante = resultado
    },

    async onGenerarComprobante (cuenta)
    {
      this.cargando = true

      try {
        const detalle = await HttpService.obtenerConConsultas('ventas.php', {
          accion: 'obtener_cuenta_apartado',
          id: cuenta.id,
          tipo: 'cuenta',
        })

        if (!detalle || !Array.isArray(detalle.productos) || detalle.productos.length < 1) {
          this.$buefy.toast.open({
            message: 'No se pudieron cargar los productos de esta cuenta',
            type: 'is-danger'
          })
          return
        }

        this.cuentaSeleccionada = detalle
        this.porPagar = Number(detalle.total || 0) - Number(detalle.pagado || 0)
        if (detalle.idNegocio) {
          const mapa = { 1: 'jiro', 2: 'ccs', 3: 'prime' }
          this.local = mapa[detalle.idNegocio] || null
        } else {
          this.local = null
        }

        this.$buefy.dialog.confirm({
          message: 'Selecciona el tamaño a imprimir',
          cancelText: 'Carta',
          confirmText: 'Tiquera',
          trapFocus: true,
          onConfirm: () =>
          {
            this.tamaño = 'tiquera'
            if (this.local) {
              this.confirmarEnvioCliente()
            } else {
              this.abrirModalLocal = true
            }
          },
          onCancel: () =>
          {
            this.tamaño = 'carta'
            if (this.local) {
              this.confirmarEnvioCliente()
            } else {
              this.abrirModalLocal = true
            }
          },
        })
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Ocurrió un error al cargar el comprobante de la cuenta',
          type: 'is-danger'
        })
      } finally {
        this.cargando = false
      }
    },

    confirmarLocal ()
    {
      this.abrirModalLocal = false;
      this.confirmarEnvioCliente();
    },

    confirmarEnvioCliente ()
    {
      this.$buefy.dialog.confirm({
        message: '¿Enviar al cliente mediante WhatsApp?',
        cancelText: 'No',
        confirmText: 'Sí',
        trapFocus: true,
        onConfirm: () =>
        {
          this.enviarCliente = true
          this.mostrarComprobante = true
        },
        onCancel: () =>
        {
          this.enviarCliente = false
          this.mostrarComprobante = true
        },
      })
    },

    onBusquedaEnFecha (fechas)
    {
      this.currentPage = 1
      this.filtros.fechaInicio = fechas && fechas[0] ? fechas[0].toISOString().split('T')[0] : ''
      this.filtros.fechaFin = fechas && fechas[1] ? fechas[1].toISOString().split('T')[0] : ''
      this.obtenerCuentas()
    },

    /** Cambio de estado: vuelve a la página 1 para no quedar fuera de rango. */
    onEstadoChange ()
    {
      this.currentPage = 1
      this.obtenerCuentas()
    },

    onPageChange (page)
    {
      this.currentPage = page
      this.obtenerCuentas()
    },

    onPerPageChange (perPage)
    {
      // Convert null (Buefy "Todos") to 0 for backend
      this.perPage = perPage === null ? 0 : perPage
      this.currentPage = 1
      this.obtenerCuentas()
    },

    async obtenerCuentas ()
    {
      this.cargando = true
      this.filtros = {
        ...this.filtros,
        clienteId: this.clienteId || null
      }

      let payload = {
        filtros: {
          ...this.filtros,
          pagina: this.perPage === null ? null : this.currentPage,
          limite: this.perPage,
        },
        accion: 'obtener_cuentas'
      }
      HttpService.obtenerConConsultas('ventas.php', payload)
        .then(resultado =>
        {
          this.cuentas = resultado.cuentas
          this.total = resultado.total
          this.tasa = resultado.tasa.valor ?? 0
          this.cuentasFiltradas = resultado.cuentasFiltradas.map(cuenta =>
          {
            return {
              nombre: cuenta.metodo_pago,
              total: `${this.formatoMonto(cuenta.total)}`,
              totalBs: `${this.formatoMonto(cuenta.totalBs)}`,
              icono: 'credit-card-outline',
              clase: 'has-text-info',
              cantidad: cuenta.cuentas_apartados_totales,
            }
          })

          this.guardarCuentasApartadosFiltrados()

          this.totalesGenerales = [
            { nombre: "# Cuentas", total: this.total, icono: "wallet", clase: "has-text-primary" },
            { nombre: "Total ", total: this.formatoMonto(resultado.totalCuentas), icono: "cash-fast", clase: "has-text-success" },
            { nombre: "Por pagar Dólares", total: this.formatoMonto(resultado.totalPorPagar), icono: "alert", clase: "has-text-danger" },
            { nombre: "Por pagar Bolívares", total: this.formatoMonto(resultado.totalPorPagar * this.tasa), icono: "alert", clase: "has-text-danger" },
            { nombre: "Pagos", total: this.formatoMonto(resultado.totalPagos), icono: "account-cash", clase: "has-text-grey-light" },
            { nombre: "# Productos", total: resultado.totalProductosVendidos, icono: "package-variant", clase: "has-text-warning" },
            { nombre: "Ganancia", total: this.formatoMonto(resultado.totalGanancia), icono: "currency-usd", clase: "has-text-info" }
          ]
          this.cargando = false
        })
    },

    guardarCuentasApartadosFiltrados ()
    {
      const cuentasFiltradas = this.cuentasFiltradas.map(cuenta =>
      {
        return {
          nombre: cuenta.nombre,
          total: cuenta.total,
          totalBs: cuenta.totalBs,
          cantidad: cuenta.cantidad,
        }
      })
      localStorage.setItem('metodos_pago', JSON.stringify(cuentasFiltradas));
    },

    onDeseleccionado ()
    {
      this.clienteId = null
      this.currentPage = 1
      // Sin cliente vuelve a la paginacion normal (evita traer todas las cuentas del sistema).
      this.perPage = 5
      this.obtenerCuentas()
    },

    onSeleccionado (cliente)
    {
      this.clienteId = cliente.id
      this.currentPage = 1

      // Con un cliente seleccionado se muestran TODAS sus cuentas, sin importar la fecha
      // ni la cantidad (null = "Todos" en el selector). El costo es bajo: la consulta
      // filtra por idx_ca_cliente.
      this.perPage = null

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() =>
      {
        this.obtenerCuentas();
      }, 500);
    },
  }
}
</script>

<style scoped>
  /* Filtro por estado: misma altura y linea que el buscador de cliente, texto centrado. */
  .filtros-reporte {
    align-items: flex-start;
  }

  .filtro-estado {
    min-width: 230px;
    max-width: 280px;
  }

  .filtro-estado ::v-deep select {
    text-align: center;
    text-align-last: center;
    font-weight: 600;
    height: 2.5em;
  }

  @media (max-width: 767px) {
    .filtro-estado {
      min-width: 100%;
      max-width: none;
    }
  }
</style>
